window.onload = function () {
  setTimeout(function () {
    scrollToLink();
  }, 1000);
};

function scrollToLink() {
  if (window.location.href.indexOf("#") != -1) {
    var match = window.location.href.split("#")[1];
    // console.log("match", match)
    var element = document.getElementById(match);

    element.scrollIntoView({ behavior: "auto", block: "start" });
  }
}

// Utility function to wrap unordered list items in <span> tags.
(() => {
  let ul_li_list = document.querySelectorAll("section > ul > li");
  for (let i = 0; i < ul_li_list.length; i++) {
    let li = ul_li_list[i];
    li.innerHTML = `<span>${li.innerHTML}</span>`;
  }
  let calloutBulletList = document.querySelectorAll("div.callout > ul > li");
  // console.log({calloutBulletList});
  for (let i = 0; i < calloutBulletList.length; i++) {
    let item = calloutBulletList[i];
    item.innerHTML = `<span style="padding-left: 5px; display: block;">${item.innerHTML}</span>`;
  }
})();

// Utility functions to create list items from the indicators in "Choosing Indicators".
(() => {
  //wrap <li>s around each list item
  let list_item_list = document.querySelectorAll(".list_item");
  for (let k = 0; k < list_item_list.length; k++) {
    list_item_list[k].outerHTML = `<li class="indicator_item">${list_item_list[k].outerHTML}</li>`;
  }

  //add classes to ul and p tags
  let indicator_item_list = document.querySelectorAll(".indicator_item");
  for (let i = 0; i < indicator_item_list.length; i++) {  
    indicator_item_list[i].parentNode.classList.add("indicator_ul");
    indicator_item_list[i].parentNode.previousSibling.classList.add("indicator_p");
  }

  //wrap <div>s around each pair of p & ul tags and add class
  let ul_list = document.querySelectorAll(".indicator_ul");
  for (let j = 0; j < ul_list.length; j++) {
    let item = ul_list[j];
    let item_p = item.previousSibling;
    let node_list = [item_p, item];
    let wrapper_div = document.createElement("div");
    wrapper_div.classList.add("indicator_div");
    wrapAll(node_list, wrapper_div);
  }
} )();

// Wrap wrapper around nodes
// Just pass a collection of nodes, and a wrapper element
// from: https://stackoverflow.com/questions/3337587/wrapping-a-set-of-dom-elements-using-javascript
function wrapAll(nodes, wrapper) {
  // Cache the current parent and previous sibling of the first node.
  var parent = nodes[0].parentNode;
  var previousSibling = nodes[0].previousSibling;

  // Place each node in wrapper.
  //  - If nodes is an array, we must increment the index we grab from 
  //    after each loop.
  //  - If nodes is a NodeList, each node is automatically removed from 
  //    the NodeList when it is removed from its parent with appendChild.
  for (var i = 0; nodes.length - i; wrapper.firstChild === nodes[0] && i++) {
      wrapper.appendChild(nodes[i]);
  }

  // Place the wrapper just after the cached previousSibling,
  // or if that is null, just before the first child.
  var nextSibling = previousSibling ? previousSibling.nextSibling : parent.firstChild;
  parent.insertBefore(wrapper, nextSibling);

  return wrapper;
}
// when the chart titles and ecoregional links are processed through markup
// new <p> tags are created. This function consolidates all the p tags in the
// titles into a single p tag and does the same for the chart links. This was desired
// at one point then decided against. Remove the code if it seems like it's not coming
// back
// function fixChartTitlesandLinks(){
//     var exhibit_titles = document.querySelectorAll('.chart-header');

//     exhibit_titles.forEach((element)=>{
//         //console.log(element)
//         var num_p = element.children.length,
//             text_array = [];

//         for(var i=0; i<num_p; i++){
//             text_array.push(element.children[i].innerHTML);
//         }
//         // console.log(text_array);
//         element.innerHTML = "<p class = 'chart-header figure exhibit'>" + text_array.join(' ') + '</p>';

//     });

//     var chart_links = document.querySelectorAll('.chart_link');

//     chart_links.forEach((element)=>{
//         text_array = [];
//         for(var i=0; i<2; i++){
//             text_array.push(element.children[i].innerHTML);
//         }
//         element.innerHTML = "<p class = 'chart_link'> " + text_array.join(' ') + '.</p>';
//     });

// }

// fixChartTitlesandLinks();
